// removed by extract-text-webpack-plugin
module.exports = {"bold":"G720130 G42bbcd"};